"use client";
import Image from "next/image";
import Link from "next/link";
import styles from "./HeaderBar.module.css";
import SearchInput from "@/components/SearchInput";
import { useSession, signOut } from "next-auth/react";
import { useState, useRef, useEffect } from "react";
import { LogOut, Settings, Heart, ListMusic, History, Search } from "lucide-react";
import { useRouter } from "next/navigation";

export default function HeaderBar() {
  const { data: session } = useSession();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  // закрытие меню при клике вне
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={styles.header}>
      {/* ЛЕВАЯ ЧАСТЬ */}
      <div className={styles.left}>
        <Link href="/" className={styles.branding}>
          <div className={styles.logo}>
            <Image
              src="/images/lira.png"
              alt="Logo"
              fill
              className={styles.logoImage}
            />
          </div>
          <span className={styles.siteName}>Mira Classic</span>
        </Link>

        <div className={styles.searchWrapper}>
          {/* Десктоп */}
          <div className={styles.searchDesktop}>
            <SearchInput />
          </div>
        </div>
      </div>

      {/* ЦЕНТР: иконки (только мобильная версия) */}
      <div className={styles.centerNav}>
        <button
          className={styles.navItem}
          onClick={() => router.push("/search-input")}
        >
          <Search size={22} />
          <span className={styles.navLabel}>Search</span>
        </button>

        <Link href="/library/favorites" className={styles.navItem}>
          <Heart size={22} />
          <span className={styles.navLabel}>Favorites</span>
        </Link>

        <Link href="/library/playlists" className={styles.navItem}>
          <ListMusic size={22} />
          <span className={styles.navLabel}>Playlists</span>
        </Link>

        <Link href="/library/history" className={styles.navItem}>
          <History size={22} />
          <span className={styles.navLabel}>History</span>
        </Link>
      </div>

      {/* ПРАВАЯ ЧАСТЬ */}
      <div className={styles.right} ref={menuRef}>
        {session ? (
          <div className={styles.avatarWrapper}>
            <div className={styles.avatar} onClick={toggleMenu}>
              {session.user?.image ? (
                <Image
                  src={session.user.image}
                  alt={session.user.name || "User"}
                  fill
                  className={styles.avatarImage}
                />
              ) : (
                <div className={styles.avatarFallback}>
                  {session.user?.name
                    ? session.user.name[0].toUpperCase()
                    : "?"}
                </div>
              )}
            </div>
            {menuOpen && (
              <div className={styles.dropdown}>
                <Link href="/account" className={styles.dropdownItem}>
                  <Settings size={16} className={styles.icon} /> Settings
                </Link>
                <button
                  onClick={() => signOut({ callbackUrl: "/" })}
                  className={styles.dropdownItem}
                >
                  <LogOut size={16} className={styles.icon} /> Sign out
                </button>
              </div>
            )}
          </div>
        ) : (
          <Link href="/auth/signin" className={styles.signInButton}>
            Sign in
          </Link>
        )}
      </div>
    </div>
  );
}
